import "./OpenNewWindow.scss";
import {HomePlant} from "../../Services/typescript-fetch-client";
import {useSearchParams} from "react-router-dom";
import {Dialog} from "primereact/dialog";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {Button} from "primereact/button";
import {Checkbox} from "primereact/checkbox";
import {RenewPlantType} from "../../Pages/Renew/RenewPlantType";

type Props = {
    type: RenewPlantType,
    plants: HomePlant[],
    unselectPlants: HomePlant[],
    displayNewWindow: boolean,
    setDisplayNewWindow: Dispatch<SetStateAction<boolean>>
}

const OpenNewWindow = (props: Props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [selectedPlants, setSelectedPlants] = useState<number[]>([]);
    
    useEffect(() => {
        setSelectedPlants(props.plants.map(p => p.id!).filter(pid => !(props.unselectPlants.map(pp => pp.id)).includes(pid)));
    }, [props.unselectPlants, props.plants])
    
    let open = () => {
        let param :string[] = [];
        if(searchParams.has("from")){
            param.push("from=" + encodeURIComponent(searchParams.get("from")!));
        }
        if(searchParams.has("to")){
            param.push("to=" + encodeURIComponent(searchParams.get("to")!));
        }
        param.push("plants=" + encodeURIComponent(selectedPlants.join(",")));
        window.open("/" + (props.type as string) + "/all?" + param.join("&"));
    };
    
    let makeFooter = () => {
        return (<div>
            <Button label="Chiudi" icon="pi pi-close" onClick={() => props.setDisplayNewWindow(false)} />
            <Button label={"Visualizza"} icon="pi pi-external-link" onClick={open} />
        </div>);
    }
    
    return (
        <Dialog onHide={() => props.setDisplayNewWindow(false)} visible={props.displayNewWindow} header="Apertura Nuova Finestra" resizable={false} dismissableMask footer={makeFooter}>
            <h3>Seleziona gli impianti che vuoi aprire in una finestra separata</h3>
            <div id="new-window-plants" className="grid">
                <div className="field-checkbox col-12">
                    <Checkbox inputId="all" value="all" checked={selectedPlants.length === props.plants.length} onChange={(e) => { 
                        if(e.checked)
                            setSelectedPlants(props.plants.map(p => p.id!));
                        else
                            setSelectedPlants([]);
                    }} />
                    <label htmlFor="all">Seleziona Tutti</label>
                </div>
                {props.plants.map(p => <div key={p.id} className="sm:col-12 md:col-6 field-checkbox">
                    <Checkbox inputId={"p-" + p.id} value={p.id} checked={selectedPlants.includes(p.id!)} onChange={(e) => {
                        if(e.checked){
                            setSelectedPlants(Array.from(new Set([...selectedPlants, Number(e.value)])));
                        }
                        else{
                            setSelectedPlants(selectedPlants.filter(pid => pid !== Number(e.value)));
                        }
                    }} />
                    <label htmlFor={"p-" + p.id}>{p.plantName}</label>
                </div>)}
            </div>
        </Dialog>
    );
};


export default OpenNewWindow;